import axios from "axios";
import { useContext, useEffect, useState } from "react";
import ChartData from "../../components/ChartData";
import Loader from "../../components/Loader";
import { AuthContext } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import AmpTable from "./AmpTable";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import NumberCard from "../../components/Card/NumberCard";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import ButtonArrow from "../../components/ButtonArrow";
import { useTranslation } from "react-i18next";

export default function AmpEvents() {
  // import context
  const { apiUrl } = useContext(AuthContext);
  const { theme } = useTheme();

  // all events
  const [totalEvents, setTotalEvents] = useState();

  // charts props
  const [dataForChart, setDataForChart] = useState({});
  const [allLabels, setAllLabels] = useState([]);
  const [titleChart, setTitleChart] = useState("");
  const [label, setLabel] = useState(false);
  const { t } = useTranslation();

  // toggle to display computer list
  const [displayArray, setDisplayArray] = useState(false);

  const getAmpEvents = async () => {
    const res = await axios(`${apiUrl}amp/events`, {
      method: "GET",
      withCredentials: true,
    });
    setTotalEvents(
      Object.values(res.data.count).reduce((acc, val) => acc + val, 0)
    );
    return res.data.count;
  };

  const events = useQuery({
    queryKey: ["ampEvents"],
    queryFn: getAmpEvents,
  });

  // function to create an object for the chart
  const setEventsForChart = () => {
    let dataChart = {};
    let allKeys = Object.keys(events.data);
    allKeys.forEach((item) => {
      const label = "Evénements";
      if (!dataChart[item]) dataChart[item] = {};

      if (!dataChart[item][label]) {
        dataChart[item][label] = events.data[item];
      }
    });

    setDataForChart(dataChart);
    setAllLabels(["Evénements"]);
    setTitleChart("Evénements Secure Endpoint");
  };

  useEffect(() => {
    events.isFetched && setEventsForChart();
  }, [events.data]);

  if (events.isError) {
    return (
      <div className="ecp-container">
        <div className="ecp-container-content-error">
          <div className="error-container">
            <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
            <div className="error-container-text">
              <h1 className="page-title">
                {t("Aucun évènement secure endpoint disponible")}
              </h1>
              <p className="page-link_home">
                <Link to="/"> {t("Revenir à l'accueil")}</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ecp-container">
      <div className="ecp-container-content">
        {!events.isLoading ? (
          <>
            <div className="ecp-container-content-header">
              <div className="ecp-container-content-header-title">
                <div className="page-title page-logo">
                  <img src="/assets/cisco_logo.png" alt="Logo de Cisco" />
                  <h1 className="page-title">Cisco Secure Endpoint</h1>
                  <ButtonArrow url={"https://id.cisco.com/"} />
                </div>
              </div>
              <button
                className="buttons-ecp buttons-ecp-new"
                onClick={() => setDisplayArray(!displayArray)}
              >
                {displayArray
                  ? t("Afficher les évènements secure endpoint")
                  : t("Afficher les équipements secure endpoint")}
              </button>
            </div>
            {!displayArray && (
              <section className="page-section">
                <NumberCard
                  title="Nombre d'évènements"
                  number={totalEvents}
                  logo={faCircleCheck}
                  color={"#AEC353"}
                  stylesIcons={"logo-certificats"}
                />
              </section>
            )}
            {!displayArray ? (
              <ChartData
                key={theme}
                dataForChart={dataForChart}
                allLabels={allLabels}
                label={label}
                titleChart={titleChart}
                typeOfChart="bar"
                theme={theme}
              />
            ) : (
              <AmpTable displayArray={displayArray} />
            )}
          </>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
}
